import API from '../../../lib/commons/api'
import { ProjectForSelection } from '../../../view/pages/ProgramManagement/programManagement'

export const fetchAllProjects = async (): Promise<ProjectForSelection[]> => {
  const response = await API.functional.request('GET', '/api/v1/projects/all')
  return response.json as ProjectForSelection[]
}
